import { inmunetApi } from '../../../../../api';

export const getSublingual = async() => {

    try {

        const { data } = await inmunetApi.get('/configuracionExpedienteClinico/sublingual');

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.sublingual;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const updateSublingual = async({ data: sublingual }) => {

    try {

        const { data } = await inmunetApi.put(`/configuracionExpedienteClinico/sublingual`, {...sublingual });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar datos';

        return data.sublingual;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar datos');
        }

    }

};